import { Observable } from "rxjs";
import { AvailabilityNotificationCreateCommandResult, AvailabilityNotificationDeleteCommandResult, ProductIdentifierDto } from "../../INTEGRA_Shop_Client";
import { InjectionToken } from "@angular/core";

export abstract class IAvailabilityNotificationApiService {

  abstract availabilityNotificationCreate(productList: ProductIdentifierDto[]): Observable<AvailabilityNotificationCreateCommandResult>;

  abstract availabilityNotificationDelete(productList: ProductIdentifierDto[]): Observable<AvailabilityNotificationDeleteCommandResult>;
}

/** Injection token which makes it possible to provide and inject the interface. */
// eslint-disable-next-line @typescript-eslint/naming-convention
export const IAvailabilityNotificationApiServiceToken = new InjectionToken<IAvailabilityNotificationApiService>('IAvailabilityNotificationApiServiceToken');
